import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ModuloService } from '../modulo/modulo.service';
import { MenuService } from './menu.service';
import { AplicacionesService } from '../aplicaciones/aplicaciones.service';

@Component({
  selector: 'app-editar-menu',
  templateUrl: './editar-menu.component.html',
  styleUrls: ['./editar-menu.component.scss']
})
export class EditarMenuComponent implements OnInit{
  readonly patron_ruta = '^([a-zA-Z0-9\\-\\_]+)(\\/[^<>:"/\\/|?*]+){0,}?$';
  menuForm = this.fb.group({
    fk_modulo: [null, Validators.required],
    menu_padre: [null],
    descripcion: [null, Validators.required],
    ruta: [null, [Validators.pattern(this.patron_ruta)]],
    ind_estado :[true]
  });

  hasUnitNumber = false;

  modulos = []
  menus = []

  constructor(private fb: FormBuilder,
              private mod_serv : ModuloService,
              private menu_serv : MenuService, 
              private app_serv : AplicacionesService) {}
  ngOnInit(): void {

    this.obtener_modulos();
    this.obtener_menu_padres();
    this.rellenar_forma();
    
  }

  onSubmit() {
    this.crear_menu();
  }

  /**
   * Funcion que se encarga de recuparar los modulos se mostraran.
   */
  private obtener_modulos(){
    if (this.mod_serv.modulos && this.mod_serv.modulos.length > 0){
      this.modulos = this.mod_serv.modulos;
    }else{
      this.mod_serv.consultar_modulos()
          .then(()=>{
            this.mod_serv = this.mod_serv.modulos
          });
    }
  }

  /**
   * Funcion que se encarga de recuperar lo menus de la aplicacion.
   */
  private obtener_menu_padres(){

    let data = {"app" : this.app_serv.get_aplicacion().id_aplicacion,
                "ind_padres" : 1
                };

    if (this.mod_serv.id_modulo){
      data["fk_modulo"] = this.mod_serv.id_modulo
    }

    this.menu_serv.consultar_menus_padres(data)
        .then(
          ()=>{
            this.menus = this.menu_serv.menu_padres
          }
        );
  }

  /**
   * crea el item de menu a registra
   */
  crear_item(){
    let estado = this.menuForm.get('ind_estado').value ? 1 : 0;
    let item = {
      "txt_descripcion": this.menuForm.get('descripcion').value,
      "ind_estado": estado,
      "fk_modulo" : this.menuForm.get('fk_modulo').value,
      "child": []
    }

    let txt_ruta = <string>this.menuForm.get('ruta').value ;

    txt_ruta = txt_ruta && txt_ruta.length ? txt_ruta : null;
    item['txt_ruta'] = txt_ruta ;

    if (this.menu_serv.id_opcion_menu){
      item['id_opcion_menu'] = this.menu_serv.id_opcion_menu;
    }

    if (this.menuForm.get('menu_padre').value){

      let id_padre =  this.menuForm.get('menu_padre').value;
      let desc_padre = '';

      for (let i = 0; i< this.menu_serv.menu_padres.length; i ++){

        if (id_padre == this.menu_serv.menu_padres[i].id_opcion_menu){
          desc_padre = this.menu_serv.menu_padres[i].txt_descripcion;
          break;
        }
      }

      let padre = {
        "id_opcion_menu" : id_padre,
        "txt_descripcion" : desc_padre, 
        "fk_modulo" : this.menuForm.get('fk_modulo').value,
        "child" : [item]
      };

      return padre;
    }

    return item;
  }

  crear_menu(){
    let nuevo_menu = this.crear_item();
    let data = {
      "app" : this.app_serv.get_aplicacion().id_aplicacion,
      "menu" : [nuevo_menu]
    }

    this.menu_serv.gestionar_menu(data);
  }

  rellenar_forma(){

    let menu = this.menu_serv.menu_edit;
    
    this.menuForm.get('fk_modulo').setValue(this.mod_serv.id_modulo);
    this.menuForm.get('menu_padre').setValue(this.menu_serv.id_menu_padre);
    
    if(menu && menu?.name){
      this.menuForm.get('descripcion').setValue(menu.name);
      this.menuForm.get('ind_estado').setValue(menu.ind_estado);
      this.menuForm.get('ruta').setValue(menu.txt_ruta);
    }
    


  }
}
